module.exports = __webpack_public_path__ + "static/1-3c0a9d18b6b00d3b79fd43054889c6c2.jpg";